import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);\n    border-radius: 40px;\n    width: 220px;\n\n    input {\n        border: 1px solid transparent;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import Picklist from 'react-rainbow-components/components/Picklist'; // eslint-disable-next-line import/prefer-default-export

export var Container = styled(Picklist)(_templateObject());